import { useEffect } from 'react';
import { useTags } from '@/features/tags/context/TagsContext';
import { useCollections } from '@/features/collections/context/CollectionsContext';
import { usePages } from '@/features/pages/context/PagesContext';
import { useTagStore } from '../../features/tags/store/useTagStore';
import { useLocation } from 'react-router-dom';
import { useCollectionStore } from '@/features/collections/stores/useCollectionStore';

/**
 * This hook initializes the application by loading necessary data
 * and setting up essential effects
 */
export function useAppInitializer() {
  const { loadCollections } = useCollections();
  const { loadPages, setCurrentPageId } = usePages();
  const resetCurrentCollection = useCollectionStore(state => state.resetCurrentCollection);
  const { refreshTags } = useTags();
  const location = useLocation();

  // Get active filters to watch for changes
  const activeFilters = useTagStore(state => state.activeFilters);

  // Initialize data on mount
  useEffect(() => {
    void refreshTags();
    void loadCollections();
  }, [refreshTags, loadCollections]);

  // Set up filter effect - reload pages when filters change
  useEffect(() => {
    void loadPages();
  }, [activeFilters, loadPages]);

  // Reset current page and collection based on route
  useEffect(() => {
    const isShared = location.pathname.includes('/shared');
    if (isShared) {
      return;
    }

    const isInCollection = location.pathname.includes('/collection/');
    const isInPage = location.pathname.includes('/page/');

    if (!isInPage) {
      console.log('Resetting current page');
      void setCurrentPageId(null);
    }

    if (!isInCollection) {
      console.log('Resetting current collection');
      resetCurrentCollection();
    }
  }, [location.pathname, setCurrentPageId, resetCurrentCollection]);

  return null;
}
